/**
 * @module app.bdc.reports.proformaCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function ProformaCtrl(
        $scope,
        $window,
        $rootScope,
        pricesService,
        tillPackService,
        orderService,
        offerService,
        napService
    ) {
        var self = {};
        self.orderForm = $rootScope.orderForm;

        if (!self.orderForm) {
            return $scope.goTo('bdc/list');
        }

        self.tillPackService = tillPackService;
        self.order = $rootScope.order;
        pricesService.setOrderForm(self.orderForm);
        pricesService.setOrder(self.order);
        self.nbTills = orderService.getNbTills(self.order.tills);
        self.nbCashDrawers = orderService.getNbCashDrawers(self.order.cashDrawers);
        self.nbOptionsByType = getNbOptionsByType(self.order.options);
        self.nbGoodwillGestures = getNbGoodwillGestures(self.order.goodwillGestures);
        self.leaserRate = orderService.isRental(self.order.contract.contractType.code)
            ? pricesService.getLeaserRate()
            : 1;
        _calculateNbLocationMonthsAndYears();

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        /**
         * Generate a proforma numero
         * @return {String} unix milliseconds timestamp
         */
        function generateNumero() {
            return moment().format('x');
        }

        /**
         * Generate a number for NAP
         * @return {String}
         *
         */
        function generateNumeroNAP() {
            return moment().format('YYYYMMDD-mm');
        }

        /**
         * Generate the unique report identifier
         * date : YYYYMMDD + postal code
         * @return {String}
         */
        self.getNumeroOffreFi = function getNumeroOffreFi() {
            var num = '';
            num += moment().format('YYYYMMDD');
            num += self.order.client.addressPostalCode;

            return num;
        };

        self.tillsPrice = 0;
        self.NAPOptions = [];
        self.printers = [];

        /**
         * calculate the total tills price
         * (All the accessories + printer) - proforma price
         */
        function _calculateTillsPrice() {
            var total = 0;
            for (var i = 0; i < self.orderForm.accessories.length; i++) {
                if (self.orderForm.accessories[i].orderType.code === self.order.orderType.code) {
                    total +=
                        self.orderForm.accessories[i].price.value *
                        (self.orderForm.accessories[i].isOnlyOne ? 1 : self.nbTills);
                }
            }

            for (var j = 0; j < self.order.options.length; j++) {
                if (self.order.options[j].optionType.code === 'IMPRIMANTE') {
                    for (var k = 0; k < self.order.options[j].prices.length; k++) {
                        if (self.order.options[j].prices[k].type === 'PROFORMA') {
                            total += self.order.options[j].prices[k].value;
                            break;
                        }
                    }
                }
            }

            if (self.order.orderType.code === 'NAP') {
                for (var k = 0; k < self.NAPOptions.length; k++) {
                    total += self.NAPOptions[k].unitPrice * self.NAPOptions[k].nbOptions;
                }
            }

            self.tillsPrice = self.order.prices.proforma - total;
        }

        function _initPrinters() {
            var found = false;
            for (var i = 0; i < self.order.options.length; i++) {
                if (self.order.options[i].optionType.code === 'IMPRIMANTE') {
                    for (var j = 0; j < self.printers.length; j++) {
                        if (self.order.options[i].id === self.printers[j].id) {
                            found = true;
                            self.printers[j]._proformaNbOptions += self.order.options[i].nbOptions;
                            break;
                        }
                    }

                    if (!found) {
                        self.order.options[i]._proformaNbOptions = self.order.options[i].nbOptions;
                        self.printers.push(self.order.options[i]);
                    }

                    found = false;
                }
            }
        }

        /**
         * Take all printers added in the controller and sum their proforma prices
         * @method _calculatePrintersTotalPrices
         * @return {Number} total: Total proforma price for of all printers of this order
         */
        function _calculatePrintersTotalPrices() {
            var total = 0;

            if (!self.printers.length) {
                return 0;
            }

            total = self.printers
                .map(function(printer) {
                    var printerPrice = printer.prices.find(function(price) {
                        return price.type.code === 'PROFORMA' && price.marketType.code === self.order.marketType.code;
                    });
                    return printerPrice ? printerPrice.value * printer.nbOptions : 0;
                })
                .reduce(function(precedentPrice, currentPrice) {
                    return precedentPrice + currentPrice;
                });
            return total;
        }

        /**
         * Init NAP options
         * Add the SCANUP and default options : for each one we calculate the unit price
         * Pay attention : the scanup and the tablet have a special unit price
         */
        function _initNAPOptions() {
            var nbOptions = 0;
            var unitPrice = 0;

            for (var j = 0; j < self.orderForm.options.length; j++) {
                if (
                    self.orderForm.options[j].orderType.code === 'NAP' &&
                    (self.orderForm.options[j].optionType.code === 'SCANUP' ||
                        self.orderForm.options[j].optionType.code === 'DEFAUT')
                ) {
                    for (var i = 0; i < self.order.options.length; i++) {
                        if (self.order.options[i].id === self.orderForm.options[j].id) {
                            nbOptions = self.order.options[i].nbOptions;
                            break;
                        }
                    }

                    self.orderForm.options[j].nbOptions = nbOptions;

                    if (self.orderForm.options[j].isDefault || self.orderForm.options[j].isScanupDevice) {
                        self.orderForm.options[j].nbOptions = self.orderForm.options[j].nbOptions += 1 || 1;

                        for (var k = 0; k < self.orderForm.options[j].prices.length; k++) {
                            if (
                                self.orderForm.options[j].prices[k].type === 'PROFORMA' ||
                                (self.orderForm.options[j].prices[k].type.code === 'ACHAT' && nbOptions > 0)
                            ) {
                                unitPrice += self.orderForm.options[j].prices[k].value;
                            }
                        }

                        unitPrice = unitPrice / self.orderForm.options[j].nbOptions;
                    }
                    else {
                        for (var k = 0; k < self.orderForm.options[j].prices.length; k++) {
                            if (self.orderForm.options[j].prices[k].type.code === 'ACHAT') {
                                unitPrice = self.orderForm.options[j].prices[k].value;
                                break;
                            }
                        }
                    }

                    self.orderForm.options[j].unitPrice = unitPrice;
                    self.NAPOptions.push(self.orderForm.options[j]);
                    nbOptions = 0;
                    unitPrice = 0;
                }
            }
        }

        function _calculateNbLocationMonthsAndYears() {
            self.nbLocationMonths = 0;
            self.nbLocationYears = 0;
            if (self.order.contract.contractType.code !== 'ACHAT') {
                self.nbLocationMonths = self.order.contract.contractType.code.substring(3);
                self.nbLocationYears = self.nbLocationMonths / 12;
            }
        }

        /* Default prices function */
        self.getUnitPrice = function getUnitPrice(priceFunction, option) {
            return priceFunction(option, false, false) / self.leaserRate;
        };

        self.getTotalPrice = function getTotalPrice(priceFunction, option, amount) {
            return (priceFunction(option, false, false) * amount) / self.leaserRate;
        };

        self.getTillPackDescription = function getTillPackDescription(order, tillType) {
            if (order.orderType.code === 'NAP') {
                return napService.getTillPackDescription(order, null, null, tillType);
            } else {
                if (tillType === 'ESSENTIEL') {
                    return 'TPV B Touch pied standard, afficheur 2 lignes, imprimante tickets';
                } else if (tillType === 'PREMIUM') {
                    return 'TPV B Touch pied standard, écran consommateur, imprimante tickets';
                } else if (tillType === 'BS_ESSENTIEL') {
                    return 'TPV B Smart pied standard, afficheur 2 lignes, imprimante tickets';
                } else if (tillType === 'BS_PREMIUM') {
                    return 'TPV B Smart pied standard, écran consommateur, imprimante tickets';
                } else if (tillType === 'BG_ESSENTIEL') {
                    return 'TPV B Green pied standard, afficheur 2 lignes, imprimante tickets';
                } else if (tillType === 'BG_PREMIUM') {
                    return 'TPV B Green pied standard, écran consommateur, imprimante tickets';
                } else if (tillType === 'BM') {
                    return "TPV B Moov, dock de chargement, logiciel d'encaissement et de gestion Bimedia, 1 routeur Wifi, 1 clavier";
                } else if (tillType === 'FORFAIT') {
                    return 'Forfait maintien de garantie sur materiel existant'
                } else if (tillType === 'PREMIUM_RECONDITIONNE') {
                    return 'TPV B Touch pied standard reconditionné, écran consommateur, imprimante tickets'
                } else if (tillType === 'BM+') {
                    return "TPV B Moov+, logiciel d'encaissement et de gestion Bimedia, 1 clavier, 1 support basic";
                } else if (tillType === 'BSW_ESSENTIEL') {
                    return 'TPV B Swift pied standard, afficheur 2 lignes, imprimante tickets';
                } else if (tillType === 'BSW_PREMIUM') {
                    return 'TPV B Swift pied standard, écran consommateur, imprimante tickets';
                }  else if (tillType === 'BW_ESSENTIEL') {
                    return 'TPV B Wide pied standard, afficheur 2 lignes, imprimante tickets';
                } else if (tillType === 'BW_PREMIUM') {
                    return 'TPV B Wide pied standard, écran consommateur, imprimante tickets';
                } else if (tillType === 'BC_ESSENTIEL') {
                    return 'TPV B Compact, imprimante tickets';
                } else {
                    return '';
                }
            }
        }

        self.tills = tillPackService.getTillsByTillCode(self.orderForm, self.order);
        let getMultiStorePrices = function(){
            let degressiveRate = pricesService.getDegressiveRate(self.order, self.nbTills, true);
            return pricesService.getDegressiveRateTillPrices(
                self.order.contract.contractType.code,
                degressiveRate
            )
        }
        let multiStorePrices= getMultiStorePrices();
        let mixedPack = tillPackService.getMixedPack(self.tills);
        let mixedPrices = pricesService.getMixedTillPrice(mixedPack, self.order.contract.contractType.code);

        self.tills = tillPackService.getPricesByTillPack(self.order, multiStorePrices, mixedPrices, self.tills);

        /**
         * Map proforma detail prices calculated in prices Service into a displayable object for proforma document
         * @return    {Object} Proforma subtotal {
         * name: {String},
         * label: {String},
         * array: {Array},
         * designationKey: {String},
         * amountKey: {String},
         * unitPriceFunction: {Function},
         * typeFilter: {Function},
         * order: {Number},
         * value: {Number},
         * show: {Boolean}
         * }
         */
        function _initProformaDetails() {
            return Object.keys(self.order.prices.proformaDetails).map(function(subtotal) {
                var current = {
                    name: subtotal,
                    label: '',
                    array: self.order.options,
                    designationKey: 'label',
                    amountKey: 'nbOptions',
                    unitPriceFunction: self.order.orderType.code === 'NAP' ? pricesService.getUnitPrice : pricesService.getOptionUnitPrice,
                    typeFilter: null,
                    order: 0,
                    value: self.order.prices.proformaDetails[subtotal],
                    show: self.order.prices.proformaDetails[subtotal] != 0
                };
                switch (subtotal) {
                    case 'till':
                        current.label = "Terminal d'encaissement";
                        current.array = self.order.tills;
                        current.amountKey = 'nbTills';
                        current.typeFilter = function() {
                            return null;
                        };
                        current.show = self.order.orderType.code === 'NAP';
                        current.order = 1;
                        break;
                    case 'promotions':
                        current.label = 'Promotions';
                        current.array = self.order.promotions;
                        current.unitPriceFunction = function(promotion) {
                            return self.order.prices.promotions[promotion.code];
                        };
                        current.typeFilter = function(promotion) {
                            return true;
                        };
                        current.show = self.order.promotions.length !== 0;
                        current.order = 2;
                        break;
                    case 'cashDrawers':
                        current.label = 'Tiroirs caisse';
                        current.array = self.order.cashDrawers;
                        current.amountKey = 'nbCashDrawers';
                        current.unitPriceFunction = pricesService.getCashDrawerUnitPrice;
                        current.typeFilter = function(cashDrawer) {
                            return true;
                        };
                        current.show = self.nbCashDrawers !== 0;
                        current.order = 3;
                        break;
                    case 'tillAccessories':
                        current.label = 'Accessoires Caisse supplémentaires';
                        current.typeFilter = function(option) {
                            return option.optionType.code === 'ACCESSOIRE_CAISSE';
                        };
                        current.show =
                            'ACCESSOIRE_CAISSE' in self.nbOptionsByType &&
                            self.nbOptionsByType['ACCESSOIRE_CAISSE'] !== 0;
                        current.order = 4;
                        break;
                    case 'software':
                        current.label = 'Logiciels';
                        current.designationKey = 'description';
                        current.typeFilter = function(option) {
                            return option.optionType.code === 'LOGICIEL_CAISSE';
                        };
                        current.show =
                            'LOGICIEL_CAISSE' in self.nbOptionsByType && self.nbOptionsByType['LOGICIEL_CAISSE'] !== 0;
                        current.order = 5;
                        break;
                    case 'options':
                        current.label = 'Matériel';
                        current.typeFilter = function(option) {
                            return optionIsHardware(option);
                        };
                        current.show = 'MATERIEL' in self.nbOptionsByType && self.nbOptionsByType['MATERIEL'] !== 0;
                        current.order = 6;
                        break;
                    case 'goodwillGestures':
                        current.label = 'Offre commerciale';
                        current.array = [{ label: 'Lancement Bimedia Pay', nbOptions: 1, code: 'scanupBimediaPayDiscount' },
                            { label: 'Offre du mois', nbOptions: 1, code: 'exceptionalOffer' },
                            {label: 'Offre premium', nbOptions:1, code: 'fullPremiumOffer'},
                            {label: 'Offre installation rapide', nbOptions:1, code: 'quickInstallOffer'},];
                        current.amountKey = 'nbOptions';
                        current.unitPriceFunction = function(goodwillGesture) {
                            return self.order.prices[goodwillGesture.code];
                        };
                        current.typeFilter = function(goodwillGesture) {
                            return isInProforma(goodwillGesture);
                        };
                        current.show = self.order.prices.proformaDetails.goodwillGestures > 0;
                        current.order = 7;
                        break;
                    case 'prestations':
                        current.label = 'Prestation';
                        current.typeFilter = function(option) {
                            return ['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(option.code);
                        };
                        current.show =
                            'PRESTATION' in self.nbOptionsByType && self.nbOptionsByType['PRESTATION'] !== 0;
                        current.order = 8;
                        break;

                }
                return current;
            });
        }

        /**
         * Get number of options by type
         * @param  {Array} options
         * @return {Object}
         */
        function getNbOptionsByType(options) {
            let nbOptions = {};
            let optionType;
            options.forEach(function(option) {
                optionType = option.optionType.code;
                if (optionIsHardware(option)) {
                    optionType = 'MATERIEL';
                }
                if (optionType in nbOptions) {
                    nbOptions[optionType] += option.nbOptions;
                }
                else {
                    nbOptions[optionType] = option.nbOptions;
                }
            });
            return nbOptions;
        }

        /**
         * Check if the option is "Matériel" type
         * @param  {Object} option
         * @return {Boolean}
         */
        function optionIsHardware(option) {
            return (
                (option.optionType.code === 'SCANUP' && !option.isService && option.billingTypeCode !== 'BURALOG') ||
                option.optionType.code === 'DEFAUT' || option.optionType.code === 'IMPRIMANTE'
            );
        }

        function isInProforma(goodwillGesture) {
            return self.order.prices[goodwillGesture.code] > 0 ;
        }

        function getNbGoodwillGestures(goodwillGestures) {
            let count = 0;
            if(goodwillGestures && goodwillGestures.amount){
                Object.keys(goodwillGestures.amount).forEach(key => {
                    if(goodwillGestures.amount[key] > 0) count++;
                })
            }

            return count;
        }

        // TRAD specific code
        if (
            tillPackService.is2017TillPack(self.order.tills, self.order.orderType.code) ||
            self.order.orderType.code === 'TRAD' || self.order.orderType.code === 'FLORAJET'
        ) {
            self.generatedNumero = generateNumero();
            self.sections = _initProformaDetails();
        }

        // NAP specific code
        if (self.order.orderType.code === 'NAP') {
            self.generatedNumero = generateNumeroNAP();
            self.sections = _initProformaDetails();
        }
        return self;
    }

    ProformaCtrl.$inject = [
        '$scope',
        '$window',
        '$rootScope',
        'pricesService',
        'tillPackService',
        'orderService',
        'offerService',
        'napService'
    ];

    angular.module('app.bdc.reports.proformaCtrl', []).controller('ProformaCtrl', ProformaCtrl);
});
